import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { OrderCallToActionContainer } from '../../../modules/OrderCallToAction/containers/OrderCallToActionContainer.js';

const OrderConfirmHeroBanner = ({ labels , contains , orderNumber  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-confirm-hero-banner"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-confirm-hero-banner__content"
    }, /*#__PURE__*/ React.createElement("h1", null, labels.title), /*#__PURE__*/ React.createElement("p", null, labels.completed, orderNumber && /*#__PURE__*/ React.createElement("strong", null, " ", orderNumber)), /*#__PURE__*/ React.createElement(Alert, {
        type: "success",
        title: labels.orderPlaced.title,
        message: labels.orderPlaced.message
    }), contains.prescriptionGlasses && /*#__PURE__*/ React.createElement("p", null, labels.orderContainsPrescriptionGlasses), contains.regular && /*#__PURE__*/ React.createElement("p", null, labels.orderContainsSunglasses), /*#__PURE__*/ React.createElement(OrderCallToActionContainer, {
        isStacked: true
    })));
};

export { OrderConfirmHeroBanner };
//# sourceMappingURL=OrderConfirmHeroBanner.js.map
